import { Tooltip } from '@mui/material';
import { Search as SearchIcon } from '@mui/icons-material';
import { StyledChip } from './SharedStyles';

export const SearchQueryDetail = ({ searchQuery }: { searchQuery?: string }) => {
  if (!searchQuery) return;

  const displayText = searchQuery.length > 20 ? `"${searchQuery.slice(0, 17)}..."` : `"${searchQuery}"`;

  return (
    <Tooltip title={searchQuery}>
      <StyledChip icon={<SearchIcon />} label={displayText} size='small' color='default' />
    </Tooltip>
  );
};
